export default __webpack_public_path__ + "de6f7f52b0ff6757a13bffa9eb7cc5ac.png";